import React from "react";
import icon from "../../assets/images/QubioIcon.svg";
import mixpanel from "mixpanel-browser";
import { Link } from "react-router-dom";
import { useAppContext } from './../../util'

const WaterMark = () => {

  const { userId, pageId } = useAppContext()

  const handleClicked = () => {
    mixpanel.track(
      "Web Qubio Badge Clicked", 
      {
        distinct_id: userId,
        stack_id: pageId,
      }
    );
  };


  return (
    <Link
      to={`https://qubio.me?utm_medium=badge&utm_source=uid-${userId || ''}`}
      onClick={handleClicked}
      className="qubioWatermark"
      target="_blank"
      style={{
        textDecoration: "none",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src={icon} alt="/QubioIcon" className="watermark" />
      <p className="watermark__text">Made with Qubio</p>
    </Link>
  );
};

export default WaterMark;
